import { render, staticRenderFns } from "./RegionSelector.vue?vue&type=template&id=3cacf16a"
import script from "./RegionSelector.vue?vue&type=script&lang=js"
export * from "./RegionSelector.vue?vue&type=script&lang=js"
import style0 from "./RegionSelector.vue?vue&type=style&index=0&id=3cacf16a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports